import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

import { translateStaticContent } from '../../../helpers/translateStaticContent';

const CalculationInfo = (props) => {
    return(
        <div className='tranfer-info'>
            <h2>
                {translateStaticContent('transferInfoHeader', 
                    props.defaultStaticContentCalc, props.activeLangStaticContentCalc)}
            </h2>
            <div className="steps">
                    <div className="step">
                        <div className="icon bank"></div>
                        <div className="title">
                            <div className="title-txt first">
                                {translateStaticContent('transferSendB1Text', 
                                    props.defaultStaticContentSend, props.activeLangStaticContentSend)}
                                 <NavLink to='/maps' rel="noreferrer">
                                    {translateStaticContent('transferSendBtn', 
                                        props.defaultStaticContentSend, props.activeLangStaticContentSend)}
                                </NavLink>  
                            </div>
                        </div>
                    </div>
                    <div className='line-dotter-1'></div>
                    <div className="step">
                        <div className="icon pasport"></div>
                        <div className="title">
                            <div className="title-txt">
                                {translateStaticContent('transferSendB2Text', 
                                    props.defaultStaticContentSend, props.activeLangStaticContentSend)}
                            </div>
                        </div>
                    </div>
                    <div className='line-dotter-2'></div>
            </div>
            <div className="steps">
                    <div className="step">
                        <div className="icon person"></div>
                        <div className="title">
                            <div className="title-txt third">
                                {translateStaticContent('transferSendB3Text', 
                                    props.defaultStaticContentSend, props.activeLangStaticContentSend)}
                            </div>
                        </div>
                    </div>
                    <div className='line-dotter-3'></div>
                    <div className="step">
                        <div className="icon doc"></div>
                        <div className="title">
                            <div className="title-txt">
                                {translateStaticContent('transferSendBText4', 
                                    props.defaultStaticContentSend, props.activeLangStaticContentSend)}
                            </div>
                        </div>
                    </div>
            </div>
        </div>
    )
}

export default CalculationInfo;

CalculationInfo.propTypes = {
    defaultStaticContentCalc: PropTypes.object,
    activeLangStaticContentCalc: PropTypes.object,
    defaultStaticContentSend: PropTypes.object,
    activeLangStaticContentSend: PropTypes.object,
}